import { USER_ROLES } from '../../auth/index';

const PERMISSIONS = [
	USER_ROLES.CSM,
	USER_ROLES.IMPLEMENTATION,
	USER_ROLES.LANGOS_APP,
	USER_ROLES.OPS,
	USER_ROLES.OWNER,
	USER_ROLES.LANGOPS,
	USER_ROLES.ADMIN,
];

export default {
	OVERVIEW: {
		ACTIVE: true,
		NAME: 'manage-overview',
		LABEL: 'Home',
		ICON: 'interface-home',
		PATH: '/',
		PERMISSIONS,
	},
};
